import React from "react";

export default function MilestoneMenuIcon({ ...rest }) {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <path
                d="M13.1909 3.74143C13.4563 3.27959 13.589 3.04867 13.7625 2.97128C13.9138 2.90378 14.0866 2.90378 14.2379 2.97128C14.4113 3.04867 14.544 3.27959 14.8094 3.74143L17.0905 7.71086C17.1887 7.88183 17.2379 7.96731 17.3067 8.02943C17.3677 8.0844 17.4395 8.12588 17.5176 8.15118C17.6058 8.17977 17.7044 8.17957 17.9016 8.17917L22.4798 8.16991C23.0124 8.16883 23.2788 8.16829 23.4325 8.27981C23.5666 8.37707 23.653 8.52675 23.6702 8.69151C23.6899 8.88042 23.5563 9.1108 23.289 9.57156L20.9919 13.5317C20.893 13.7023 20.8435 13.7876 20.8242 13.8783C20.807 13.9586 20.807 14.0415 20.8242 14.1218C20.8435 14.2125 20.893 14.2978 20.9919 14.4683L23.289 18.4285C23.5563 18.8893 23.6899 19.1197 23.6702 19.3086C23.653 19.4733 23.5666 19.623 23.4325 19.7203C23.2788 19.8318 23.0124 19.8312 22.4798 19.8302L17.9016 19.8209C17.7044 19.8205 17.6058 19.8203 17.5176 19.8489C17.4395 19.8742 17.3677 19.9157 17.3067 19.9706C17.2379 20.0328 17.1887 20.1182 17.0905 20.2892L14.8094 24.2586C14.544 24.7205 14.4113 24.9514 14.2379 25.0288C14.0866 25.0963 13.9138 25.0963 13.7625 25.0288C13.589 24.9514 13.4563 24.7205 13.1909 24.2586L10.9099 20.2892C10.8116 20.1182 10.7625 20.0328 10.6936 19.9706C10.6327 19.9157 10.5608 19.8742 10.4828 19.8489C10.3945 19.8203 10.2959 19.8205 10.0988 19.8209L5.52059 19.8302C4.98793 19.8312 4.7216 19.8318 4.56785 19.7203C4.43375 19.623 4.34733 19.4733 4.33015 19.3086C4.31045 19.1197 4.44408 18.8893 4.71135 18.4285L7.00845 14.4683C7.10739 14.2978 7.15686 14.2125 7.17621 14.1218C7.19334 14.0415 7.19334 13.9586 7.17621 13.8783C7.15686 13.7876 7.10739 13.7023 7.00845 13.5317L4.71135 9.57156C4.44408 9.1108 4.31045 8.88042 4.33015 8.69151C4.34733 8.52675 4.43375 8.37707 4.56785 8.27981C4.7216 8.16829 4.98793 8.16883 5.52059 8.16991L10.0988 8.17917C10.2959 8.17957 10.3945 8.17977 10.4828 8.15118C10.5608 8.12588 10.6327 8.0844 10.6936 8.02943C10.7625 7.96731 10.8116 7.88183 10.9099 7.71086L13.1909 3.74143Z"
                stroke="#2A2E44"
                strokeWidth="2.33337"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect
                x="15.1432"
                y="15.1433"
                width="11.6486"
                height="11.6486"
                rx="5.82431"
                fill="#F4F4F7"
            />
            <g clipPath="url(#clip0_8804_24748)">
                <rect
                    x="16.3081"
                    y="16.3081"
                    width="9.3189"
                    height="9.3189"
                    rx="4.65945"
                    fill="#F4F4F7"
                />
                <path
                    d="M24.8505 20.6123V20.9696C24.85 21.8069 24.5789 22.6216 24.0775 23.2922C23.5762 23.9629 22.8715 24.4535 22.0685 24.6909C21.2656 24.9283 20.4074 24.8998 19.622 24.6096C18.8365 24.3194 18.166 23.7831 17.7102 23.0807C17.2545 22.3783 17.038 21.5474 17.0931 20.7119C17.1482 19.8764 17.4719 19.0811 18.0159 18.4446C18.56 17.8081 19.2952 17.3645 20.1119 17.1799C20.9286 16.9954 21.7831 17.0798 22.5479 17.4206"
                    fill="#F4F4F7"
                />
                <path d="M24.8505 17.861L20.9676 21.7478L19.8027 20.5829" fill="#F4F4F7" />
                <path
                    d="M24.8505 20.6123V20.9696C24.85 21.8069 24.5789 22.6216 24.0775 23.2922C23.5762 23.9629 22.8715 24.4535 22.0685 24.6909C21.2656 24.9283 20.4074 24.8998 19.622 24.6096C18.8365 24.3194 18.166 23.7831 17.7102 23.0807C17.2545 22.3783 17.038 21.5474 17.0931 20.7119C17.1482 19.8764 17.4719 19.0811 18.0159 18.4446C18.56 17.8081 19.2952 17.3645 20.1119 17.1799C20.9286 16.9954 21.7831 17.0798 22.5479 17.4206M24.8505 17.861L20.9676 21.7478L19.8027 20.5829"
                    stroke="#2A2E44"
                    strokeWidth="0.582431"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_8804_24748">
                    <rect
                        x="16.3081"
                        y="16.3081"
                        width="9.3189"
                        height="9.3189"
                        rx="4.65945"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
